module.exports = __webpack_public_path__ + "static/email-151de73a0dde28eb95cfd3eecb5677a7.jpg";